import { AxiosRequestConfig } from 'axios';
import { IAxiosSilentFailConfig } from '@/shared/interfaces/axios-silent-fail-config';

/**
 * Uses axios config to conditionally determine if a site id should be given on a request or not.
 */
export const conditionalSiteIdPaths: ((config: AxiosRequestConfig) => boolean)[] = [
  (config) => (
    !!config.url?.startsWith('/website-api/objects_has_tags')
    && !config.params?.where?.includes('model:building-photos')
  ),
];

/**
 * Endpoints that should fail silently, with custom handling logic.
 */
export const silentFailEndpoints: IAxiosSilentFailConfig[] = [
  {
    path: '/listing-scores-api',
    requestTimeout: 10000,
    onError: async (app: Vue) => {
      app?.$store.commit('listing-scores/setIsListingScoresApiAvailable', false);
    },
    onRequest: async (app: Vue) => {
      app?.$store.commit('listing-scores/setIsListingScoresApiAvailable', true);
    },
    state: (app: Vue) => app.$store.getters['listing-scores/isListingScoresApiAvailable'],
  },
];
